import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AccessControlWrapper } from './AccessControlWrapper';
import { buildButton } from '../utils';

/** the object props for building a PageHeaderButton from Utils */
const ButtonObjectPropType = PropTypes.shape({
  /** function to be called on click */
  action: PropTypes.func,
  /** bsPrefix applied to button */
  class: PropTypes.string,
  /** is button disabled */
  disabled: PropTypes.bool,
  /** content rendered inside the button */
  label: PropTypes.any,
  /** any additional props to pass to the Button component */
  props: PropTypes.object,
});

/** props for building a button by passing an element or building from Utils */
const ButtonPropType = PropTypes.oneOfType([PropTypes.element, ButtonObjectPropType]);

/** the props for creating a PageHeaderButton */
export const PageHeaderButtonPropType = PropTypes.oneOfType([ButtonPropType, PropTypes.arrayOf(ButtonPropType)]);

/** renders a button or series of buttons in the PageHeader */
export class PageHeaderButton extends Component {
  static propTypes = {
    /** the button being rendered */
    actionButton: PageHeaderButtonPropType,
  };

  renderButton = () => {
    const { actionButton } = this.props;
    if (Array.isArray(actionButton)) {
      return actionButton.map(button => this.renderButtonFromObject(button));
    } else if (actionButton.action) {
      return this.renderButtonFromObject(actionButton);
    } else {
      return actionButton;
    }
  };

  renderButtonFromObject = actionButton => {
    return (
      <AccessControlWrapper {...actionButton}>
        {buildButton({
          func: actionButton.action,
          label: actionButton.label,
          bsPrefix: 'btn',
          variant: actionButton.class,
          disabled: actionButton.disabled,
          props: actionButton.props,
        })}
      </AccessControlWrapper>
    );
  };

  render() {
    return <div className="header-action-button">{this.renderButton()}</div>;
  }
}
